import { render, staticRenderFns } from "./UserCompetitionsFuture.vue?vue&type=template&id=d5d68b48&scoped=true&"
import script from "./UserCompetitionsFuture.vue?vue&type=script&lang=js&"
export * from "./UserCompetitionsFuture.vue?vue&type=script&lang=js&"
import style0 from "./UserCompetitionsFuture.vue?vue&type=style&index=0&id=d5d68b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d68b48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5d68b48')) {
      api.createRecord('d5d68b48', component.options)
    } else {
      api.reload('d5d68b48', component.options)
    }
    module.hot.accept("./UserCompetitionsFuture.vue?vue&type=template&id=d5d68b48&scoped=true&", function () {
      api.rerender('d5d68b48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserCompetitionsFuture.vue"
export default component.exports